export const WarningModel = (props) => {
  return (
    <div className="modal modalTrash modal--open">
      <div className="modal__dialog">
        <div className="modal__content">
          <div className="modal__header">
            <h4 className="modal__body--title">
              {props?.isTopup ? "Add Topup" : "Change Plan!"}
            </h4>
            <p className="para">
              {props?.isTopup
                ? "Are you sure you want to add topup? Please note that your default credit card will be charged accordingly."
                : "Are you sure you want to change your plan? Please note that your default credit card will be charged accordingly."}
            </p>
          </div>
          <div className="modal__footer">
            <div className="btn__group">
              <button onClick={props.onReject} className="btn btn__white">
                No
              </button>
              <button onClick={props.onAccept} className="btn btn__primary">
                Yes
              </button>
            </div>
          </div>
        </div>
      </div>
      <div className="modal__backdrop"></div>
    </div>
  );
};
